<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero" />
      <template #footerShort>
        <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] justify-between">
          <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] md:items-end -md:order-2">
            <div>
              <AtomButtonDropdown :items="clubItems" :initial-index="initialClub" @select="onClubSelect" />
            </div>
          </div>
          <!-- <AtomButton class="self-end -md:order-1 -md:w-full" :to="`/timetable/${selectedClub}/adult`"
            >РАСПИСАНИЕ</AtomButton
          > -->
        </div>
      </template>
    </SectionHero>
    <SectionDefault>
      <Builder :context="{ club: selectedClub, trainersPerDirection: trainersPerDirection }" :blocks="blocks" />
    </SectionDefault>
  </main>
</template>

<script>
// import AtomButton from '../../components/atoms/AtomButton'
import AtomButtonDropdown from '../../components/atoms/AtomButtonDropdown'
import Builder from '../../components/builder/Builder'
import pageBuilder from '../../components/mixins/pageBuilder.js'
import OrganismHero from '../../components/organisms/layouts/OrganismHero'
import SectionDefault from '../../components/templates/layouts/SectionDefault'
import SectionHero from '../../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'personal-training',
  fetch: async ({ $axios, route }) => {
    const clubs = await $axios
      .get(`/api/clubs`)
      .then(({ data }) => data.filter(({ personalTraining }) => personalTraining))
      .catch(() => [])
    const querySlug = route.query.club
    const selectedClub = clubs.some(({ slug }) => slug === querySlug) ? querySlug : clubs[0]?.slug
    const [trainers] = await Promise.all([
      $axios
        .get(`/api/fitbase/${selectedClub}/trainers?locale=ru`)
        .then(({ data }) => data)
        .catch(() => []),
    ])

    const excludedTrainers = {
      encore_yasenevo: new Set(['костомаха игорь', 'пономарева ирина', 'чернышова вера', 'петухов святослав']),
      encore_khodynka: new Set(['костомаха игорь']),
      encore_city: new Set(['петухов святослав']),
    }

    const filteredTrainers = trainers.filter(trainer => {
      if (!trainer.photo) return false

      const excludedForClub = excludedTrainers[selectedClub]
      if (!excludedForClub) return true

      const fullName = `${trainer.surname?.toLowerCase().trim()} ${trainer.name?.toLowerCase().trim()}`
      return excludedForClub.has(fullName) == false
    })

    return {
      clubs,
      trainers: filteredTrainers,
      selectedClub,
    }
  },
})

export default {
  name: 'FitnessPersonal',
  components: {
    Builder,
    SectionDefault,
    SectionHero,
    OrganismHero,
    AtomButtonDropdown,
    // AtomButton,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      hero: {
        variant: 'dark-parallax',
        title1: 'персональный',
        title2: 'тренинг',
        imagePosition: '!object-top',
        image: 'studio/10-hero.webp',
        imageWrap: 'img-border-0',
        imageMobile: 'studio/10-hero-mobile.webp',
        breadcrumbs: c.$breadcrumbs.personalTraining(),
      },
      trainers: [],
      clubs: [],
      selectedClub: null,
      showPerPage: 12,
    }
  },
  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Service',
            name: 'Персональный тренинг',
            description: 'Индивидуальные тренировки с сертифицированными тренерами Encore Fitness.',
            provider: {
              '@type': 'Organization',
              name: 'Encore Fitness',
              url: 'https://encorefitness.ru/',
            },
          },
        },
      ],
    }
  },
  computed: {
    trainersPerDirection() {
      const trainersPerDirection = new Map() // Map<directionName, Set<trainer[]>>
      this.trainers.forEach(trainer => {
        const { custom_fields: customFields = [] } = trainer

        if (customFields.length == 0) return

        customFields.forEach(({ name, key }) => {
          if (!name) return

          if (trainersPerDirection.has(name) == false) trainersPerDirection.set(name, [])

          if (key?.value != '1') return

          trainersPerDirection.get(name).push(trainer)
        })
      })

      return [...trainersPerDirection]
        .map(([directionName, trainers]) => ({
          directionName,
          trainers,
        }))
        .filter(
          ({ trainers, directionName }) =>
            trainers.length > 0 && directionName.toLowerCase().trim() !== 'функциональное тестирование',
        )
    },
    clubItems() {
      return this.clubs.map(club => ({ text: club.title, slug: club.slug }))
    },
    initialClub() {
      return this.clubItems.findIndex(({ slug }) => slug === this.selectedClub)
    },
  },
  watchQuery: ['club'],
  methods: {
    onClubSelect(i) {
      this.$router.push({ query: { club: this.clubs[i].slug } })
    },
  },
}
</script>
